import React, { useState } from "react";
import {
  Box,
  Typography,
  IconButton,
  Grid,
  Avatar,
  Modal,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import CheckIcon from "@mui/icons-material/Check";

const imgBaseUrl = "https://daalchini.s3.ap-south-1.amazonaws.com/dcprod/";
export default function CategoriesModal({ viewall, setSelectedId, selectedId,setViewall,categories,setCategoriesWiseVmItems,fetchCategoriesWise }) {


  const handleClick = (e, item_id) => {
    if (selectedId === item_id) {
      setSelectedId(null);
     setCategoriesWiseVmItems([]);
     setViewall(false)
    } else {
       fetchCategoriesWise(item_id);
      setSelectedId(item_id);
      setViewall(false)
    }
  };

  return (
    <Modal open={viewall} onClose={() => setViewall(false)}>
      <Box
        sx={{
          position: "absolute",
          bottom: 0,
          width: "100%",
          height: "75vh",
          bgcolor: "#f5f6f8",
          borderTopLeftRadius: 24,
          borderTopRightRadius: 24,
          boxShadow: 24,
          p:"20px",
           pb: "96px", // 🔥 IMPORTANT
          overflowY: "auto",

        }}
      >
        {/* Drag Handle */}
        <Box
          sx={{
            width: 40,
            height: 5,
            bgcolor: "#ccc",
            borderRadius: 10,
            mx: "auto",
            mb: 2,
          }}
        />

        {/* Header */}
        <Box display="flex" alignItems="center" mb={2}>
          <Typography flex={1} fontWeight={700} fontSize={18}>
            Categories
          </Typography>

          <IconButton onClick={() => setViewall(false)}>
            <CloseIcon />
          </IconButton>
        </Box>

        {/* Grid */}
        <Grid container spacing={3}>
          {categories.map((item) => {
            const selected = selectedId === item.id;

            return (
              <Grid item xs={3} key={item.id}>
                <Box
                  textAlign="center"
                  sx={{ cursor: "pointer" }}
                  onClick={(e) => handleClick(e, item.id)}
                >
                  <Box position="relative">
                    <Avatar
                     src={`${imgBaseUrl}${item.image_path}`}
                      sx={{
                        width: 70,
                        height: 70,
                        margin: "0 auto",
                        bgcolor: selected ? "#e6f4ea" : "#fff",
                        border: selected
                          ? "2px solid #2e7d32"
                          : "1px solid #eee",
                        boxShadow: selected
                          ? "0 6px 16px rgba(46,125,50,0.25)"
                          : "0 4px 12px rgba(0,0,0,0.08)",
                        transition: "0.25s",
                      }}
                    />

                    {selected && (
                      <Avatar
                        sx={{
                          width: 22,
                          height: 22,
                          bgcolor: "#2e7d32",
                          position: "absolute",
                          bottom: -2,
                          right: "calc(50% - 35px)",
                        }}
                      >
                        <CheckIcon sx={{ fontSize: 14, color: "#fff" }} />
                      </Avatar>
                    )}
                  </Box>

                  <Typography
                    variant="body2"
                    mt={1}
                    fontWeight={500}
                    color={selected ? "#2e7d32" : "text.secondary"}
                  >
                    {item.name}
                  </Typography>
                </Box>
              </Grid>
            );
          })}
        </Grid>
      </Box>
    </Modal>
  );
}
